import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
import { Developer } from '../../utils/types';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
interface TalentCapsuleCardProps {
  developer: Developer;
  featured?: boolean;
}
export const TalentCapsuleCard = ({
  developer,
  featured = false
}: TalentCapsuleCardProps) => {
  return <Link to={`/developers/${developer.id}`} className="block h-full" data-id="element-37">
      <div className={`h-full bg-surface rounded-2xl border border-border hover:border-text-muted/30 transition-all duration-300 overflow-hidden group hover:shadow-xl hover:shadow-black/5 ${featured ? 'md:col-span-2 flex flex-col md:flex-row' : 'flex flex-col'}`} data-id="element-38">
        {/* Header / Cover */}
        <div className={`relative bg-gradient-to-r from-gray-200 to-gray-100 dark:from-gray-900 dark:to-gray-800 ${featured ? 'md:w-1/3 h-48 md:h-auto' : 'h-24'}`} data-id="element-39">
          {/* Status Badge */}
          <div className="absolute top-4 right-4" data-id="element-40">
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${developer.status === 'available' ? 'bg-green-500/10 text-green-500 border border-green-500/20' : 'bg-surface text-text-muted border border-border'}`} data-id="element-41">
              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${developer.status === 'available' ? 'bg-green-500' : 'bg-text-muted'}`} data-id="element-42"></span>
              {developer.status === 'available' ? 'Available' : 'Unavailable'}
            </span>
          </div>

          {/* Avatar */}
          <div className={`absolute ${featured ? 'bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 md:top-1/2 md:left-1/2 md:-translate-y-1/2' : 'bottom-0 left-6 transform translate-y-1/2'}`} data-id="element-43">
            <div className="relative" data-id="element-44">
              <img src={developer.avatar} alt={developer.name} className={`rounded-full border-4 border-surface object-cover ${featured ? 'w-32 h-32' : 'w-20 h-20'}`} data-id="element-45" />
              {developer.verified && <div className="absolute bottom-1 right-1 bg-surface rounded-full p-1 shadow-md" data-id="element-46">
                  <CheckCircleIcon className="w-4 h-4 text-primary" data-id="element-47" />
                </div>}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className={`flex-1 p-6 ${featured ? 'md:p-8 md:pl-24 pt-16' : 'pt-12'}`} data-id="element-48">
          <div className="flex justify-between items-start mb-2" data-id="element-49">
            <div data-id="element-50">
              <h3 className="font-bold text-lg text-text-main group-hover:text-primary transition-colors" data-id="element-51">
                {developer.name}
              </h3>
              <p className="text-sm text-text-muted" data-id="element-52">{developer.title}</p>
            </div>
            <div className="text-right" data-id="element-53">
              <div className="font-bold text-text-main" data-id="element-54">
                €{developer.hourlyRate}/hr
              </div>
              <div className="flex items-center text-xs text-text-muted justify-end mt-1" data-id="element-55">
                <MapPinIcon className="w-3 h-3 mr-1" data-id="element-56" />
                {developer.country}
              </div>
            </div>
          </div>

          {/* Skills */}
          <div className="mt-4 flex flex-wrap gap-2" data-id="element-57">
            {developer.skills.slice(0, featured ? 6 : 3).map(skill => <span key={skill.name} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-background text-text-muted border border-border" data-id="element-58">
                {skill.name}
              </span>)}
            {developer.skills.length > (featured ? 6 : 3) && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-background text-text-muted border border-border" data-id="element-59">
                +{developer.skills.length - (featured ? 6 : 3)}
              </span>}
          </div>

          {/* Bio (Featured only) */}
          {featured && <p className="mt-4 text-text-muted text-sm line-clamp-2" data-id="element-60">
              {developer.bio}
            </p>}
        </div>
      </div>
    </Link>;
};